import { useMutation } from '@tanstack/react-query'
import { AuthAccountRegistrationResponse, register } from 'api/auth'
import GeoContext from 'contexts/geoContext'
import { useContext } from 'react'

interface UserRegisterVariables {
  email: string
  givenName?: string
  surname?: string
  password: string
}

interface Params {
  onSuccess?: (data: AuthAccountRegistrationResponse) => void
  // Optional brand override. Defaults to the app brand (LEBT) when omitted.
  brand?: App.BrandName
}

function useUserRegisterMutation(params: Params) {
  const { currentRegionCode } = useContext(GeoContext)

  const registrationMutation = useMutation<AuthAccountRegistrationResponse, App.ApiCallFailure, UserRegisterVariables>({
    mutationFn: (variables) => {
      return register(variables, {
        ...(params.brand ? { brand: params.brand } : {}),
        includeCredentials: false,
        regionCode: currentRegionCode,
      })
    },
    onSuccess: params.onSuccess,
  })

  return registrationMutation
}

export default useUserRegisterMutation
